import { Button } from "PFComponents/button";
import { Icon } from "PFComponents/icon";
import React, { JSX } from "react";
import { useTranslation } from "react-i18next";

import { useAnalyticsModalContext } from "../analytics_modal_context_provider";

type AddNewExportReportProps = {
  className?: string;
};

export const AddNewExportReport = ({ className }: AddNewExportReportProps): JSX.Element => {
  const { open } = useAnalyticsModalContext();
  const { t } = useTranslation("insights");

  return (
    <div className={className}>
      <Button onClick={() => open()} kind="text">
        <Icon name="add" />
        <span>{t("reports.addNew")}</span>
      </Button>
    </div>
  );
};
